import { render } from "../templates/newsGrid.html?vue&type=template&id=7ca383a4"
import script from "./newsGrid.vue?vue&type=script&lang=js"
export * from "./newsGrid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__